import React from 'react'

import { Tooltip, useIsTruncated } from '@/components/ui/tooltip'

interface SelectTruncationTooltipProps {
  children: (props: {
    ref: React.RefObject<HTMLElement | null>
    onMouseEnter: VoidFunction
  }) => React.ReactNode
  label: string
}

// Note: minWidth 0 lets the tooltip's flex wrappers shrink with the clamped text instead of
// growing to its full width.
const TOOLTIP_STYLE: React.CSSProperties = { minWidth: 0 }

export const SelectTruncationTooltip = ({ children, label }: SelectTruncationTooltipProps) => {
  const { check, isTruncated, ref } = useIsTruncated<HTMLElement>()

  return (
    <Tooltip
      disabled={!isTruncated}
      style={TOOLTIP_STYLE}
      trigger={children({ onMouseEnter: check, ref })}
    >
      {label}
    </Tooltip>
  )
}
